module.exports = __webpack_public_path__ + "static/media/GN.cbeb23fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GN.svg
// module id = 2160
// module chunks = 7